var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWithdrawUtglNative = function SvgWithdrawUtglNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.404 1.154A1.155 1.155 0 0 0 31.25 0h-30C.612 0 .096.516.096 1.154v9.23A1.155 1.155 0 0 0 1.25 11.54h4.615v17.307A1.155 1.155 0 0 0 7.02 30h18.462a1.155 1.155 0 0 0 1.153-1.154V11.54h4.616a1.155 1.155 0 0 0 1.154-1.154V1.154Zm-8.077 26.538H8.173V6.923h16.154v20.77Zm5.77-18.461h-3.463V6.923h.577a1.154 1.154 0 1 0 0-2.308H5.288a1.154 1.154 0 1 0 0 2.308h.577v2.308H2.404V2.308h27.692V9.23Z",
    fill: "#305992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.437 23.89c.45.447 1.176.447 1.626 0l4.004-3.998a1.153 1.153 0 1 0-1.632-1.632l-2.031 2.03V11.54a1.154 1.154 0 1 0-2.308 0v8.751l-2.03-2.03a1.154 1.154 0 1 0-1.633 1.632l4.004 3.998Z",
    fill: "#CC8528"
  })));
};
export default SvgWithdrawUtglNative;